import React, { useEffect, useState } from "react";
import Ink from "react-ink";
import Axios from "axios";
import { GET_ADDRESS_FROM_COORDINATES } from "../../../../../configs";
import { useNavigate } from "react-router-dom";

const GpsSelector = ({ fetchGpsAutomaticallyAndroid }) => {
	const navigate = useNavigate();
	const [gpsLoading, setGpsLoading] = useState(false);

	// ---------------- AUTO FETCH FOR ANDROID ----------------
	useEffect(() => {
		if (fetchGpsAutomaticallyAndroid) {
			if (navigator.userAgent === "FoodomaaAndroidWebViewUA") {
				if (window.Android !== "undefined") {
					if (localStorage.getItem("userAlreadySelectedLocation") === null) {
						getMyLocation();
					}
				}
			}
		}
	}, []);

	// ---------------- GET CURRENT LOCATION ----------------
	const getMyLocation = () => {
		startLoading();

		const location = navigator && navigator.geolocation;
		if (location) {
			location.getCurrentPosition(
				(position) => {
					reverseLookup(position.coords.latitude, position.coords.longitude);
				},
				(error) => {
					stopLoading();
					console.log(error);

					if (navigator.userAgent !== "FoodomaaAndroidWebViewUA") {
						alert(localStorage.getItem("gpsAccessNotGrantedMsg"));
					}
				},
				{ timeout: 5000 }
			);
		} else {
			stopLoading();
		}
	};

	// ---------------- REVERSE LOOKUP COORDINATES ----------------
	const reverseLookup = (lat, lng) => {
		Axios.post(GET_ADDRESS_FROM_COORDINATES, { lat, lng })
			.then((response) => {
				const myLocation = [
					{
						formatted_address: response.data,
						geometry: {
							location: { lat, lng }
						}
					}
				];

				handleGeoLocationClick(myLocation);
			})
			.catch((error) => {
				console.warn(error.response?.data);
			});
	};

	// ---------------- HANDLE SELECTED GEOLOCATION ----------------
	const handleGeoLocationClick = (results) => {
		localStorage.setItem("geoLocation", JSON.stringify(results[0]));

		stopLoading();

		if (fetchGpsAutomaticallyAndroid) {
			// Save user business location
			const loc = JSON.parse(localStorage.getItem("geoLocation"));
			const userSetAddress = {
				lat: loc.geometry.location.lat,
				lng: loc.geometry.location.lng,
				address: loc.formatted_address,
				house: null,
				tag: null,
				businessLocation: true
			};

			localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
			localStorage.setItem("userAlreadySelectedLocation", "true");

			window.location.reload();
		} else {
			navigate("/my-location");
		}
	};

	// ---------------- MANUAL LOADING SCREEN ----------------
	const startLoading = () => {
		const el = document.getElementById("gpsLoadingScreen");
		if (el) el.classList.remove("hidden");
	};

	const stopLoading = () => {
		const el = document.getElementById("gpsLoadingScreen");
		if (el) el.classList.add("hidden");
	};

	return (
		<>
			<div
				className="p-15 d-flex justify-content-center align-items-center gps-selection-block"
				style={{
					backgroundColor: localStorage.getItem("cartColorBg"),
					color: localStorage.getItem("cartColorText"),
					position: "relative"
				}}
				onClick={getMyLocation}
			>
				<div className="mr-15">
					<p className="mb-0">{localStorage.getItem("useGpsMessage")}</p>
				</div>

				<div className="useGpsBtn">
					{localStorage.getItem("useGpsButtonText")}
				</div>

				<Ink duration={500} />
			</div>
		</>
	);
};

export default GpsSelector;